import qs from "query-string";
import { useEffect, useState } from "react";
import { Provider } from "react-redux";
import { useLocation } from "react-router-dom";
import KycApplicationContext from "../Context/KYCApplicationContext/KYCApplicationContext";
import WidgetStore from "../Store/WidgetStore";
import MainAppLayout from "./../Components/Layouts/MainAppLayout";
function Home() {
  const appKeyIndex = 0;
  const encrypedModeIndex = 1;
  const profileIdIndex = 2;
  const profileStatusTypeIndex = 3;
  const holderTypeIndex = 4;
  const [currentHolder, setCurrentHolder] = useState();
  const [currentWorkflow, setCurrentWorkflow] = useState();
  const [currentWidget, setCurrentWidget] = useState();
  const [mode, setMode] = useState();
  const [disableForm, setDisableForm] = useState();
  const [widgetShortNameToShow, setWidgetShortNameToShow] = useState("");
  const [moveToHolder, setMoveToHolder] = useState("");

  //get the query params from the URL
  const queryParam = qs.parse(useLocation().search);

  const [isLoaded, setIsLoaded] = useState(false);

  function setSessionStorageValues(paramsArray) {
    //only 2 params will be  in the initial URL
    if (paramsArray.length == 2) {
      sessionStorage.setItem("AppKey", paramsArray[appKeyIndex]);
      sessionStorage.setItem("EncryptedMode", paramsArray[encrypedModeIndex]);
      sessionStorage.setItem("ProfileId", "");
      sessionStorage.setItem("ProfileStatusType", "");
      sessionStorage.setItem("HolderType", "");
    } else if (paramsArray.length > 1) {
      sessionStorage.setItem("AppKey", paramsArray[appKeyIndex]);
      sessionStorage.setItem("EncryptedMode", paramsArray[encrypedModeIndex]);
      sessionStorage.setItem("ProfileId", paramsArray[profileIdIndex]);
      sessionStorage.setItem("HolderType", paramsArray[profileStatusTypeIndex]);
      sessionStorage.setItem("ProfileStatusType", paramsArray[holderTypeIndex]);
    }
  }

  useEffect(() => {
    console.log(queryParam);
    let params = queryParam.kyc_st;
    if (params !== undefined) {
      const paramsArray = params.split("/");

      // set the query params values in the session storage
      setSessionStorageValues(paramsArray);
    }
    setIsLoaded(true);
    window.history.pushState({}, "", window.location.pathname);
  }, [queryParam.kyc_st]);

  return (
    <>
      {isLoaded && (
        <Provider store={WidgetStore}>
          <KycApplicationContext.Provider
            value={{
              currentHolder: currentHolder,
              setCurrentHolder: setCurrentHolder,
              currentWorkflow: currentWorkflow,
              setCurrentWorkflow: setCurrentWorkflow,
              currentWidget: currentWidget,
              setCurrentWidget: setCurrentWidget,
              mode: mode,
              setMode: setMode,
              disableForm: disableForm,
              setDisableForm: setDisableForm,
              widgetShortNameToShow: widgetShortNameToShow,
              setWidgetShortNameToShow: setWidgetShortNameToShow,
              moveToHolder: moveToHolder,
              setMoveToHolder: setMoveToHolder,
            }}
          >
            <MainAppLayout></MainAppLayout>
          </KycApplicationContext.Provider>
        </Provider>
      )}
    </>
  );
}

export default Home;
